import React from 'react';
import { useSearchParams, useNavigate } from 'react-router-dom';
import { Card, CardContent, CardHeader, CardTitle } from '../components/ui/card';
import { Button } from '../components/ui/button';
import { XCircle, Home, RefreshCw } from 'lucide-react';

const PaymentCancel = () => {
  const [searchParams] = useSearchParams();
  const navigate = useNavigate();
  const paymentRef = searchParams.get('ref');

  return (
    <div className="min-h-screen bg-gradient-to-br from-gray-900 via-gray-800 to-gray-900 flex items-center justify-center p-4">
      <Card className="w-full max-w-md bg-gray-800 border-gray-700">
        <CardHeader className="text-center">
          <div className="mx-auto w-20 h-20 bg-orange-500/20 rounded-full flex items-center justify-center mb-4">
            <XCircle className="h-12 w-12 text-orange-500" />
          </div>
          <CardTitle className="text-2xl text-white">Payment Cancelled</CardTitle>
        </CardHeader>
        <CardContent className="space-y-6">
          <p className="text-gray-400 text-center">
            Your payment was cancelled. Your booking has not been processed and no charges have been made.
          </p>

          {paymentRef && (
            <div className="bg-gray-700/50 rounded-lg p-4">
              <div className="flex justify-between text-sm">
                <span className="text-gray-400">Reference:</span>
                <span className="text-white font-mono">{paymentRef}</span>
              </div>
            </div>
          )}

          <div className="bg-blue-500/10 border border-blue-500/30 rounded-lg p-4">
            <p className="text-blue-300 text-sm">
              You can retry the payment at any time from your bookings page. 
              Your booking will remain pending until payment is completed.
            </p>
          </div>

          <div className="flex gap-3 pt-4">
            <Button
              variant="outline"
              onClick={() => navigate('/')}
              className="flex-1 border-gray-600 text-gray-300 hover:bg-gray-700"
            >
              <Home className="h-4 w-4 mr-2" />
              Home
            </Button>
            <Button
              onClick={() => navigate('/my-bookings')}
              className="flex-1 bg-yellow-500 hover:bg-yellow-600 text-black"
            >
              <RefreshCw className="h-4 w-4 mr-2" />
              View Bookings
            </Button>
          </div>
        </CardContent>
      </Card>
    </div>
  );
};

export default PaymentCancel;
